import { request } from "./client";
import type {
  CorrectionRequest,
  CorrectionRequestsResponse,
  CreateCorrectionRequestInput,
} from "./types";

/** POST /api/v1/tawa/anomalies/correction-requests — le worker justifie l'anomalie
 * ouverte portée par source_event_id. 404 sans anomalie ouverte, 409 si déjà
 * justifiée, 403 si l'event n'est pas le sien. */
export async function createCorrectionRequest(
  input: CreateCorrectionRequestInput,
): Promise<CorrectionRequest> {
  return request<CorrectionRequest>({
    method: "POST",
    url: "/anomalies/correction-requests",
    data: {
      source_event_id: input.source_event_id,
      justification: input.justification,
      proposed_at: input.proposed_at,
    },
  });
}

/** GET /api/v1/tawa/anomalies/correction-requests — toutes les anomalies persistées
 * du worker courant, tous statuts. */
export async function listMyCorrectionRequests(): Promise<CorrectionRequestsResponse> {
  return request<CorrectionRequestsResponse>({
    method: "GET",
    url: "/anomalies/correction-requests",
  });
}

/** GET /api/v1/tawa/manager/correction-requests — équipe du manager, tout le tenant
 * pour un admin. */
export async function listTeamCorrectionRequests(): Promise<CorrectionRequestsResponse> {
  return request<CorrectionRequestsResponse>({
    method: "GET",
    url: "/manager/correction-requests",
  });
}

/** POST /api/v1/tawa/manager/correction-requests/{id}/approve */
export async function approveCorrectionRequest(
  id: string,
): Promise<CorrectionRequest> {
  return request<CorrectionRequest>({
    method: "POST",
    url: `/manager/correction-requests/${encodeURIComponent(id)}/approve`,
  });
}

/** POST /api/v1/tawa/manager/correction-requests/{id}/reject — classe l'anomalie
 * (status ignored), définitif. */
export async function rejectCorrectionRequest(
  id: string,
  reason: string,
): Promise<CorrectionRequest> {
  return request<CorrectionRequest>({
    method: "POST",
    url: `/manager/correction-requests/${encodeURIComponent(id)}/reject`,
    data: { reason },
  });
}
